import React, { useEffect, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  surveyType,
  useErrorService,
  PrintableArea,
  buildAggregatedCombinedSummaryFileBase,
} from '@abroad/components'
import {
  WisdomAssessmentResult,
  ProsperityAssessmentResult,
  AwarenessAssessmentResult,
} from '../components'
import API from '../utils/API'

const ViewEcosystemAssessment = () => {
  const { ecoSystemName } = useParams()
  const history = useHistory()
  const Error = useErrorService()
  const [survey, setSurvey] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const querySurveyType = query.get('surveyType')
  const pdfFileNameBase = buildAggregatedCombinedSummaryFileBase(
    ecoSystemName,
    querySurveyType,
  )

  useEffect(() => {
    const getEcoSystemAssessment = async () => {
      try {
        const { data } =
          await API.AdminAPI.companyList.getSurveyByEcoSystemName(
            ecoSystemName,
            search,
          )
        setSurvey(data)
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          history.replace('/404')
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }

    if (ecoSystemName) {
      getEcoSystemAssessment()
    } else {
      history.replace(`/admin/networks`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecoSystemName, search, history])

  return (
    <>
      <Helmet>
        <title>{`${ecoSystemName}'s Assessment | Abroad`}</title>
        <meta name='title' content={`${ecoSystemName}'s Assessment | Abroad`} />
        <meta
          property='og:title'
          content={`${ecoSystemName}'s Assessment | Abroad`}
        />
        <meta
          property='twitter:title'
          content={`${ecoSystemName}'s Assessment | Abroad`}
        />
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/admin/network/${ecoSystemName}`}
        />
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/network/${ecoSystemName}`}
        />
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/network/${ecoSystemName}`}
        />
      </Helmet>
      <main>
        {querySurveyType === surveyType?.WISDOM ? (
          <WisdomAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Network Wisdom Assessment'
            subHeaderText={`${decodeURIComponent(
              ecoSystemName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : querySurveyType === surveyType.PROSPERITY ? (
          <ProsperityAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Network True Prosperity Assessment'
            subHeaderText={`${decodeURIComponent(
              ecoSystemName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : (
          <AwarenessAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Network Awareness Assessment'
            subHeaderText={`${decodeURIComponent(
              ecoSystemName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization.'
            pdfFileNameBase={pdfFileNameBase}
          />
        )}
      </main>
      <PrintableArea printSelector='main' />
    </>
  )
}

export default ViewEcosystemAssessment
